// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

type PropTypes = {|
  onClick: boolean => void,
  active: boolean,
  className?: string,
|};

const Hamburger = (props: PropTypes) => {
  const className = cx(styles.hamburger, props.className, { [styles.isActive]: props.active });
  const onClick = () => {
    props.onClick(!props.active);
  };

  return (
    <button className={className} type="button" onClick={onClick} data-testid="hamburguer">
      <span className={styles.screenReader}>Open menu</span>
    </button>
  );
};

export default Hamburger;
